/* eslint-disable */
import { isIE } from './shared_functions';

const onAjaxComplete = function (callback) {
  XMLHttpRequest.prototype.send = (function (orig) {
    return function () {
      if (!isIE) { // For non-IE browsers
        this.addEventListener('loadend', callback, false);
      } else { // For IE browsers
        const xhr = this;
        const waiter = setInterval(() => {
          if (xhr.readyState && xhr.readyState === 4) {
            clearInterval(waiter);
            callback();
          }
        }, 50);
      }
      return orig.apply(this, arguments);
    };
  }(XMLHttpRequest.prototype.send));
};

export default onAjaxComplete;
